import { createReactor } from 'human-redux-reactor';
import { refreshUser } from '../features/user/userReactor';
import { refreshAppsList, refreshUnifiedPlatformAppsList } from '../features/appsList/appsListReactors';
import { refreshEditors } from '../features/editors/editorsReactors';

export default createReactor({
    reactors: [refreshUser, refreshAppsList, refreshUnifiedPlatformAppsList, refreshEditors],
    runIdle: true,
    quietPeriod: 1000,
    dev: process.env.NODE_ENV !== 'production',
});
